(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jbkits-product-culture"] && !Shopify.designMode) return;
  try {
    
let jbPersonalisationNode=null;
let jbPersonalisationProductId=null;
function jbPersonalisationState(){const info=document.querySelector('product-info');if(!info)return;if(jbPersonalisationProductId!==info.dataset.productId){jbPersonalisationNode=null;jbPersonalisationProductId=info.dataset.productId;}const option=Array.from(info.querySelectorAll('variant-selects fieldset')).find(function(field){return /custom name|personali/i.test(field.querySelector('legend')?.textContent||'');});const slot=info.querySelector('[data-jb-personalisation-slot]');if(!option||!slot)return;let input=info.querySelector('input[name="properties[Custom Name]"]:not([data-jb-custom-name])');if(input)jbPersonalisationNode=input.closest('.tpo_option-container');else if(jbPersonalisationNode)input=jbPersonalisationNode.querySelector('input[name="properties[Custom Name]"]');if(!input||!jbPersonalisationNode)return;if(jbPersonalisationNode.parentElement!==slot){slot.insertBefore(jbPersonalisationNode,slot.firstChild);}if(!jbPersonalisationNode.dataset.jbOptionEvents){jbPersonalisationNode.addEventListener('input',jbPersonalisationState);jbPersonalisationNode.addEventListener('change',function(event){if(event.target.matches('input:not([type="radio"]),textarea')){jbPersonalisationState();event.stopPropagation();}});jbPersonalisationNode.dataset.jbOptionEvents='ready';}const enabled=/^yes/i.test(option.querySelector('input:checked')?.value||'');slot.hidden=!enabled;jbPersonalisationNode.hidden=!enabled;input.disabled=!enabled;input.removeAttribute('form');const form=info.querySelector('product-form form[data-type="add-to-cart-form"]');if(form){let property=form.querySelector('[data-jb-custom-name]');if(!property){property=document.createElement('input');property.type='hidden';property.name='properties[Custom Name]';property.dataset.jbCustomName='true';form.appendChild(property);}property.value=input.value;property.disabled=!enabled;}}

function jbPurchaseNavigation(){const info=document.querySelector('product-info');if(info){jbPersonalisationState();new MutationObserver(jbPersonalisationState).observe(info,{childList:true,subtree:true});info.addEventListener('change',jbPersonalisationState);info.addEventListener('submit',jbPersonalisationState,true);}const button=document.querySelector('product-info [name="add"]');const link=document.querySelector('.jb-pdp-mobile-return');if(!button||!link)return;new IntersectionObserver(function(entries){link.hidden=entries[0].isIntersecting;},{threshold:0.2}).observe(button);}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',jbPurchaseNavigation);}else{jbPurchaseNavigation();}
document.addEventListener('click',function(event){const link=event.target.closest('[data-jb-return]');if(!link)return;const target=document.querySelector('product-info .product__info-container');if(target){event.preventDefault();target.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'start'});const input=target.querySelector('input[type="radio"]:checked,select');if(input)input.focus({preventScroll:true});}});

  } catch(e) { console.error(e); }
})();
})();
